// extracted by mini-css-extract-plugin
export default {"infoText":"infoText_infoText__-o1PR"};